import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IMemberClubScheme } from "src/models/Customers/MemberClub.models";

interface MemberClubSchemeState {
  memberClubSchemes: IMemberClubScheme[];
  memberClubSchemeToEdit: IMemberClubScheme | null;
}

const initialState: MemberClubSchemeState = {
  memberClubSchemes: [],
  memberClubSchemeToEdit: null,
};

const memberClubSchemeSlice = createSlice({
  name: "MemberClubScheme",
  initialState,
  reducers: {
    setMemberClubSchemeList: (
      state,
      action: PayloadAction<IMemberClubScheme[]>
    ) => {
      state.memberClubSchemes = action.payload;
    },
    concatListMemberClubScheme: (
      state: MemberClubSchemeState,
      action: PayloadAction<IMemberClubScheme[]>
    ) => {
      state.memberClubSchemes = [
        ...state.memberClubSchemes.concat(action.payload),
      ];
    },
    setMemberClubSchemeToEdit: (
      state,
      action: PayloadAction<IMemberClubScheme | null>
    ) => {
      state.memberClubSchemeToEdit = action.payload;
    },
    addMemberClubScheme: (state, action: PayloadAction<IMemberClubScheme>) => {
      state.memberClubSchemes.push(action.payload);
    },
    updateMemberClubScheme: (
      state,
      action: PayloadAction<IMemberClubScheme>
    ) => {
      let itemIndex = state.memberClubSchemes.findIndex(
        item => item.memberClubSchemeId === action.payload.memberClubSchemeId
      );
      if (itemIndex !== -1) state.memberClubSchemes[itemIndex] = action.payload;
    },
    deleteMemberClubScheme: (state, action: PayloadAction<number>) => {
      const newArray = state.memberClubSchemes.filter(
        item => item.memberClubSchemeId !== action.payload
      );
      state.memberClubSchemes = newArray;
    },
  },
});

export const {
  setMemberClubSchemeList,
  concatListMemberClubScheme,
  setMemberClubSchemeToEdit,
  addMemberClubScheme,
  updateMemberClubScheme,
  deleteMemberClubScheme,
} = memberClubSchemeSlice.actions;

export default memberClubSchemeSlice.reducer;
